var map = {
	"./Frame.svg": "ad83",
	"./ansible.svg": "5826",
	"./appstore.svg": "b20c",
	"./big_cross.svg": "ac91",
	"./blogging.svg": "06d6",
	"./cal.svg": "4cf5",
	"./camera.svg": "24e5",
	"./check_box.svg": "6fc5",
	"./copy.svg": "8aac",
	"./delete.svg": "0d45",
	"./dots.svg": "93d2",
	"./error_outline.svg": "f450",
	"./events_ico.svg": "9b7f",
	"./exit.svg": "a2ab",
	"./eye.svg": "7364",
	"./eye_visible.svg": "e488",
	"./fb.svg": "55c7",
	"./forward.svg": "bdb1",
	"./galka.svg": "3a46",
	"./google_play.svg": "9e95",
	"./inst.svg": "5f32",
	"./map.svg": "0443",
	"./mastercard.svg": "8302",
	"./mir.svg": "a50e",
	"./news_ico.svg": "9f44",
	"./photo_ico.svg": "1428",
	"./photo_ico_active.svg": "55a6",
	"./picture.svg": "4092",
	"./qr-code.svg": "3a65",
	"./qrcode.svg": "8b10",
	"./share.svg": "bd5b",
	"./support_ico.svg": "fe48",
	"./tarif_ico.svg": "f5cb",
	"./user.svg": "6aed",
	"./user_ico.svg": "3806",
	"./visa.svg": "30e2",
	"./vk.svg": "13e3",
	"./wallet.svg": "4f4a",
	"./web.svg": "72d5",
	"./wed.svg": "50b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";